import {
  ActionButtonProps,
  Box,
  BoxProps,
  cardNumber,
  convertHexToRGBA,
  cvvSchema,
  expiry,
  Form,
  ModBox,
  Spacer,
  Text,
  TextProps,
} from '@jfs/ui-new'
import React from 'react'
import { CardNumberTextInput } from '../../../comps/CardNumberTextInput'
import { PaySecurelyButton } from '../../../comps/PaySecurelyButton'
import { PGTextInput } from '../../../comps/PGTextInput'
import { MerchantTheme } from '../../../data/models/Config'
import { useStores } from '../../../data/store'
import { CVV } from './CVV'
import { Expiry } from './Expiry'

export const MetaDataTags = ({ metadata, onSubmit, amount, isLoading, title, headerText }: any) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))

  const componentMapper = (item: any) => ({
    cardnumber: {
      theme,
      ComponentName: CardNumberTextInput,
      fieldName: item.name,
      validationSchema: cardNumber,
    },
    expiry: {
      theme,
      ComponentName: Expiry,
      fieldName: item.name,
      validationSchema: expiry,
    },
    cvv: {
      theme,
      ComponentName: CVV,
      fieldName: item.name,
      validationSchema: cvvSchema,
    },
  })
  const formData = (inputData: any) => {
    const retData =
      inputData.map((item: any, index: any) => {
        const mapper = componentMapper(item)
        return (
          mapper[item.name.toLowerCase() as keyof typeof mapper] ?? {
            ComponentName: PGTextInput,
            theme,
            fieldName: item.name,
            testID: `inputField${index}`,
            label: item.label,
            maxLength: item.name === 'mobile' ? 10 : undefined,
            leftComponent: item.name === 'mobile' ? <Text>+91</Text> : undefined,
            textType: item.name === 'mobile' ? 'numOnly' : undefined,
            validations: item.validations,
            infoText: item?.info,
          }
        )
      }) ?? []

    return [
      {
        formItems: [...retData],
        verticalSpacing: 12,
        onSubmit: () => {
          return 'end'
        },
      },
    ]
  }

  const renderActionButton = ({ values, isValid }: ActionButtonProps) => {
    const metaData: any = {}
    Object.keys(values).forEach((key: string) => {
      if (typeof values[key] === 'object') {
        if (!(values[key] as any).isValid) {
          isValid = false
        }
        metaData[key] = (values[key] as any).value
      } else {
        metaData[key] = values[key] as any
      }
    })
    return (
      <Box justifyContent="center" alignItems="center">
        <Spacer size={16} />
        <PaySecurelyButton
          disabled={!isValid}
          amount={amount}
          onPress={() => onSubmit(metaData)}
          isLoading={isLoading}
          title={title}
        />
      </Box>
    )
  }

  const style = styleFunc(theme as any)

  return (
    <>
      <ModBox {...style.container} show={metadata.length > 0}>
        <Text {...style.header}>{headerText}</Text>
      </ModBox>
      <Form
        formData={formData(metadata)}
        initialValues={{}}
        actionButtons={renderActionButton as any}
        container={({ children }) => <Box ph={20}>{children}</Box>}
      />
    </>
  )
}

const styleFunc = (theme: typeof MerchantTheme.properties) => ({
  container: {
    borderTopWidth: 6,
    borderColor: convertHexToRGBA(theme.bodyTextColor, 10) as any,
    pt: 18,
    ph: 18,
  } as BoxProps,
  header: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as any,
    fontFamily: 'jiotype-Medium',
    lineHeight: 18,
  } as TextProps,
})
